var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-carousel',{attrs:{"cycle":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src,"reverse-transition":"reverse-transition","transition":"slide-x-reverse-transition"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }